import * as ACTIONTYPE from '../constants/actiontypes'

const _default = {
   isShown: false
};

export default function (state = _default, action) {
    switch (action.type) {
        case ACTIONTYPE.UNAVAILABLE_POPUP_SHOW:
            return {...state, isShown: true};
        case ACTIONTYPE.UNAVAILABLE_POPUP_HIDE:
            return {...state, isShown: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/UnavailablePopupReducer.js